import { CheckCircleOutlined, CloseCircleOutlined, PlusOutlined } from "@ant-design/icons";
import inputEdit from "@assets/redesign/icons/inputEdit.svg";
import Icon from "@components/global/new/Icon/Icon";
import { Button, Flex } from "antd";
import { useMemo } from "react";
import { useIntl } from "react-intl";
import styles from "./NotesForm.module.scss";
import { INotesFormProps, useNotesControl } from "./useUserNotesControl";

export default function NotesForm(props: INotesFormProps) {
  const { formatMessage } = useIntl();
  const control = useNotesControl(props);

  const title = useMemo(() => {
    if (props.type === "admin_note")
      return formatMessage({ id: "machines.more.settings.personal.title" });

    if (props.type === "user_note" && !control.isAdmin) {
      return formatMessage({
        id: "machines.more.settings.personal.title_user",
      });
    } else if (props.type === "user_note") {
      return formatMessage({
        id: "machines.more.settings.personal.title_user",
      });
    }

    if (props.type === "sync_note")
      return formatMessage({
        id: "machines.more.settings.personal.title_sync",
      });
  }, [props.type]);

  return (
    <form
      className={styles.user_notes}
      onSubmit={control.onSubmit}
      ref={control.form}
    >
      <Flex align="center" justify="space-between"><span className={styles.label}>{title}</span></Flex>
      <div className={styles.container}>
        <textarea
          className={styles[props.type]}
          disabled={!control.edit}
          id={props.type}
          onKeyDown={control.onSubmitByEnter}
          onChange={e => control.onChangeValue(e.target.value)}
          placeholder="Enter the message"
          value={control.currentValue}
          name="notes_text"
          ref={control.textArea}
        />
        {props.type !== "sync_note" && (control.edit
          ? <div className={styles.controls}>
            <Button
              size="small"
              type="text"
              onClick={() => {
                control.setEdit(false);
                control.form.current?.requestSubmit();
              }}
            >
              <CheckCircleOutlined
                style={{ color: "green", cursor: "pointer" }}
              />
            </Button>
            <Button
              size="small"
              type="text"
              onClick={() => {
                control.setEdit(false);
                control.onChangeValue(props.value || "");
              }}
            >
              <CloseCircleOutlined
                style={{ cursor: "pointer" }}
              />
            </Button>
          </div>
          : props.editable && <Icon src={inputEdit} onClick={() => control.setEdit(true)} className={styles.editIcon} />)}
      </div>
    </form>
  );
}
